export { LogoComponent, type LogoVariant } from './logo.component';
